<div class="itero-note">
  <h3 class="itero-note__name">{{note.name}}</h3>
  <span  class="itero-note__timestamp" *ngIf="noteTime">{{noteTime}}</span>
  <p class="itero-note__body">
    {{note.noteBody}}
  </p>
</div>
